<mat-form-field appearance="outline" [ngClass]="{'dark': dark}">
    <mat-select class="currency-selector" panelClass="lower-panel" [(value)]="selectedCurrency" (selectionChange)="currencyChanged($event)">
        <mat-select-trigger>
            <img class="flag" style="height:12px" [src]="'https://cdn.ipregistry.co/flags/wikimedia/' + getCcFromCr(selectedCurrency) + '.svg'" />
            <span style="margin-left: 8px;"> {{ selectedCurrency }}</span>
        </mat-select-trigger>
        <mat-option *ngFor="let currency of availableCurrecies; let i = index" [value]="currency">
            <img class="flag" style="height:12px" [src]="'https://cdn.ipregistry.co/flags/wikimedia/' + getCcFromCr(currency) + '.svg'" />
            <span style="margin-left: 8px;"> {{ currency }}</span>
        </mat-option>
    </mat-select>
</mat-form-field>